import { Alert, Button } from '@rentflowdev/ui'
import { Component, type ErrorInfo, type ReactNode } from 'react'

interface Props {
	children: ReactNode
}

interface State {
	hasError: boolean
	error: Error | null
}

export class ErrorBoundary extends Component<Props, State> {
	public state: State = { hasError: false, error: null }

	public static getDerivedStateFromError(error: Error): State {
		return { hasError: true, error }
	}

	public componentDidCatch(error: Error, info: ErrorInfo) {
		console.error('[ErrorBoundary]', error, info.componentStack)
	}

	public render() {
		if (this.state.hasError) {
			return (
				<div className="flex items-center justify-center min-h-screen">
					<div className="w-full max-w-sm p-8">
						<Alert variant="error">
							{import.meta.env.DEV
								? this.state.error?.message ?? 'Unknown error'
								: 'Произошла ошибка. Попробуйте перезагрузить страницу.'}
						</Alert>
						<Button
							variant="secondary"
							size="full"
							className="mt-4"
							onClick={() => window.location.reload()}
						>
							Перезагрузить
						</Button>
					</div>
				</div>
			)
		}

		return this.props.children
	}
}
